// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plan-selected{border-width:4px;--tw-border-opacity:1;border-color:rgba(96,165,250,var(--tw-border-opacity))}.text-xxs{font-size:1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
